import React, { useState } from 'react';
import { Wand2, ChevronDown, ChevronUp, ShieldAlert } from 'lucide-react';

export function PromptInput({
  prompt,
  onChangePrompt,
  negativePrompt,
  onChangeNegativePrompt,
  onMagicEnhance,
  isEnhancing
}) {
  const [showNegative, setShowNegative] = useState(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <label style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8' }}>
            Prompt de Generación
          </label>
          <button
            type="button"
            onClick={onMagicEnhance}
            disabled={isEnhancing}
            style={{
              background: 'none',
              border: 'none',
              color: '#c084fc',
              fontSize: '11px',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              cursor: 'pointer'
            }}
          >
            <Wand2 size={13} /> {isEnhancing ? 'Mejorando...' : 'Magic Enhance (Gemini)'}
          </button>
        </div>
        <textarea
          value={prompt}
          onChange={(e) => onChangePrompt(e.target.value)}
          rows={3}
          placeholder="Describe la escena, iluminación y movimiento..."
          style={{
            width: '100%',
            background: '#141724',
            border: '1px solid rgba(255,255,255,0.09)',
            borderRadius: '8px',
            padding: '10px 12px',
            color: '#f8fafc',
            fontSize: '13px',
            lineHeight: '1.4',
            resize: 'none',
            outline: 'none',
            fontFamily: 'inherit'
          }}
        />
      </div>

      {/* Acordeón de Prompt Negativo */}
      <div>
        <button
          type="button"
          onClick={() => setShowNegative(!showNegative)}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#94a3b8',
            fontSize: '11px',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            cursor: 'pointer',
            padding: 0
          }}
        >
          <ShieldAlert size={12} color="#f43f5e" />
          <span>Prompt Negativo (Filtro de deformaciones)</span>
          {showNegative ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </button>

        {showNegative && (
          <textarea
            value={negativePrompt || ''}
            onChange={(e) => onChangeNegativePrompt?.(e.target.value)}
            rows={2}
            placeholder="Deformed face, blurry, bad anatomy, flicker, extra fingers, cartoonish..."
            style={{
              width: '100%',
              marginTop: '6px',
              background: 'rgba(244,63,94,0.04)',
              border: '1px solid rgba(244,63,94,0.2)',
              borderRadius: '8px',
              padding: '8px 10px',
              color: '#fda4af',
              fontSize: '11px',
              lineHeight: '1.3',
              resize: 'none',
              outline: 'none',
              fontFamily: 'inherit'
            }}
          />
        )}
      </div>
    </div>
  );
}

